import { z } from 'zod';
import isMongoId from '../../helpers/is-mongo-id';
import withPaginationParamsOptional from '../../helpers/with-pagination-params-optional';

export const GetOrganisationByIdInput = z.object({
  id: z.string().refine(isMongoId()),
});

export const ListOrganisationsInput = withPaginationParamsOptional(
  z.object({
    search: z.string().optional(),
    parentId: z.string().optional(),
    organisationId: z.string().optional(),
    firmId: z.string().optional(),
    isParent: z.boolean().optional(),
    isChild: z.boolean().optional(),
    includeInvestmentValues: z.boolean().optional(),
  }),
  ['name'],
);

export type ListOrganisationsInput = z.infer<typeof ListOrganisationsInput>;

export const DeleteOrganisationByIdInput = z.object({
  id: z.string().refine(isMongoId()),
});
